import { useMemo, useContext, useEffect } from "react";
import { Context } from "./context/ProductsProvider";
import { useAuthContext } from "./context/AuthContext";
import { CategoryForMen, CategorySlideHome, CategoryForWomen} from "./components/List";
import {PopularItems} from "./components/StockImages";
import Slider from "./components/Slider";
import { Footer } from "./components/Footer";
import "./App.css";

function Space() {
  return (
    <div className="space"></div>
  ) 
};

function App() {
  const { state, read } = useContext(Context)
  const { authenticate } = useAuthContext()
  const count = useMemo(() => {
    return `${state.items.length} item${state.items.length > 1 ? 's': ''}`
  }, [state.items])

  useEffect(() => {
    read()
    authenticate()
  }, [])

  return (
    <>
    <div className="AppWrapper">
      <Slider />
      <PopularItems  items={state.items}/>
      <CategorySlideHome />
      <CategoryForWomen />
      <CategoryForMen />
      <Space />
      <Footer />
    </div>
    </>
  );
 
}
export default App;
